import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { useCart } from "../context/CartContext";

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const { cartItems } = useCart();
    const location = useLocation();

    const isActive = (path) =>
        location.pathname === path
            ? "border-b-2 border-yellow-400 font-bold"
            : "border-b-2 border-transparent hover:border-yellow-300";

    return (
        <>
            {/* HEADER */}
            <header className="sticky top-[40px] left-0 w-full z-[50]">
                <div className="h-[72px] w-full bg-[#b11226] shadow-lg">
                    <div className="max-w-7xl mx-auto h-full px-4 flex items-center justify-between text-white">

                        {/* LEFT : CALL (MOBILE ONLY) */}
                        <div className="w-1/4 flex items-center md:hidden">
                            <a
                                href="tel:+919752772880"
                                className="flex items-center gap-1 text-[11px] font-semibold"
                            >
                                <span className="text-lg">📞</span>
                                <span className="flex flex-col leading-none">
                                    <span>Call Now</span>
                                    <span className="text-[10px] opacity-90">
                                        +91 9752772880
                                    </span>
                                </span>
                            </a>
                        </div>

                        {/* CENTER : LOGO */}
                        <Link
                            to="/"
                            className="w-1/2 md:w-auto flex flex-col items-center justify-center leading-none"
                        >
                            <img
                                src="/images/logo-balaji.jpeg"
                                alt="श्री बालाजी मसाला"
                                className="h-14 w-14 rounded-full object-contain bg-white p-1"
                            />

                        </Link>

                        {/* RIGHT : MENU (MOBILE) */}
                        <div className="w-1/4 flex justify-end md:hidden">
                            <button
                                onClick={() => setOpen(!open)}
                                className="text-2xl"
                                aria-label="Menu"
                            >
                                ☰
                            </button>
                        </div>

                        {/* DESKTOP MENU */}
                        <nav className="hidden md:flex space-x-8 font-semibold items-center">
                            <Link to="/" className={isActive("/")}>Home</Link>
                            <Link to="/about" className={isActive("/about")}>About Us</Link>
                            <Link to="/products" className={isActive("/products")}>Products</Link>
                            <Link to="/quality" className={isActive("/quality")}>Quality</Link>
                            <Link to="/blogs" className={isActive("/blogs")}>Blogs</Link>
                            <Link to="/contact" className={isActive("/contact")}>Contact</Link>

                            <Link to="/cart" className="relative text-xl">
                                🛒
                                {cartItems.length > 0 && (
                                    <span className="absolute -top-2 -right-3 bg-yellow-400 text-black text-xs px-2 rounded-full">
                                        {cartItems.length}
                                    </span>
                                )}
                            </Link>
                        </nav>

                        {/* DESKTOP CALL BUTTON */}
                        <a
                            href="tel:+919752772880"
                            className="hidden md:block bg-yellow-400 text-black px-4 py-2 rounded-lg font-bold"
                        >
                            Call Now
                        </a>
                    </div>
                </div>
            </header>

            {/* MOBILE MENU */}
            {open && (
                <div className="fixed top-[72px] left-0 w-full bg-[#b11226] text-white px-6 py-6 z-[45] md:hidden">
                    <nav className="flex flex-col divide-y divide-white/20 text-lg font-semibold">
                        <Link onClick={() => setOpen(false)} to="/" className={`py-3 ${isActive("/")}`}>Home</Link>
                        <Link onClick={() => setOpen(false)} to="/about" className={`py-3 ${isActive("/about")}`}>About Us</Link>
                        <Link onClick={() => setOpen(false)} to="/products" className={`py-3 ${isActive("/products")}`}>Products</Link>
                        <Link onClick={() => setOpen(false)} to="/quality" className={`py-3 ${isActive("/quality")}`}>Quality</Link>
                        <Link onClick={() => setOpen(false)} to="/contact" className={`py-3 ${isActive("/contact")}`}>Contact</Link>
                        <Link onClick={() => setOpen(false)} to="/cart" className="py-3">
                            🛒 Cart ({cartItems.length})
                        </Link>
                    </nav>

                    <a
                        href="tel:+919752772880"
                        className="mt-6 block bg-yellow-400 text-black text-center py-3 rounded-xl font-bold text-lg"
                    >
                        Call Now
                    </a>
                </div>
            )}
        </>
    );
}
